import { Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import Title from '../../components/Title';
import Button from '../../components/ui/buttons/Button';

type FeedbackStatusCardProps = {
  emoji: string;
  title: string;
  body: string;
  action?: { label: string; onClick: () => void };
  hideBackLink?: boolean;
  children?: ReactNode;
};

const goToLeaseEnd = () => window.location.assign('/');

const FeedbackStatusCard = ({
  emoji,
  title,
  body,
  action,
  hideBackLink,
  children,
}: FeedbackStatusCardProps) => (
  <Flex direction="column" align="center" justify="center" flex={1} minH="60vh" px={6}>
    <Flex
      direction="column"
      align="center"
      textAlign="center"
      w="full"
      maxW="420px"
      border={{ base: 'none', md: '1px solid' }}
      borderColor={{ md: 'platinum' }}
      borderRadius="16px"
      px={{ base: 0, md: 8 }}
      py={{ base: 0, md: 10 }}
    >
      <Text fontSize="44px" mb={4}>
        {emoji}
      </Text>
      <Title fontSize="26px" lineHeight={1.2} letterSpacing="-0.3px">
        {title}
      </Title>
      <Text mt={3} fontSize="16px" lineHeight={1.6} color="leaseEndGray" fontWeight={500}>
        {body}
      </Text>
      {children}
      {action && (
        <Button w="full" mt={7} textTransform="uppercase" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
      {!hideBackLink &&
        (action ? (
          <Button variant="link" mt={4} fontSize="14px" onClick={goToLeaseEnd}>
            Back to Lease End
          </Button>
        ) : (
          <Button w="full" mt={7} textTransform="uppercase" onClick={goToLeaseEnd}>
            Back to Lease End
          </Button>
        ))}
    </Flex>
  </Flex>
);

export default FeedbackStatusCard;
